import React, {useState} from 'react';
import ReactSVG from 'react-svg';
import { ShareViaEmailModal, ShareViaSmsModal, PrintButton, useNeuroMessages } from "@ignitesales/neuro-application";
import commonUI from "../utils/commonUI.jsx";

const SocialActionsBar = ({ detailsUrl }) => {
  const [ showEmailModal, setEmailModalView ] = useState(false);
  const [ showSmsModal, setSmsModalView ] = useState(false);
  const { formatIntlMessage } = useNeuroMessages();
  const componentClass = 'action-bar';
  
  const visitABranch = formatIntlMessage({ id: 'socialActions.visitABranch'});
  const email = formatIntlMessage({ id: 'socialActions.email'});
  const print = formatIntlMessage({ id: 'socialActions.print'});
  const sms = formatIntlMessage({ id: 'socialActions.sms'});

  const goToLocationPage = () => {
    window.open(formatIntlMessage({ id: 'socialActions.visitABranch.link'}));
  }

  return <div className={componentClass}>
    <button className={`${componentClass}__action`} onClick={() => goToLocationPage()}>
      <ReactSVG src="/classpath/assets/images/marker-blue.svg" title={visitABranch}/>
      <div className={`${componentClass}__action__description`}>{visitABranch}</div>
    </button>
    <button className={`${componentClass}__action`} onClick={() => setEmailModalView(true)}>
      <ReactSVG src="/classpath/assets/images/mail-blue.svg" title={email}/>
      <div className={`${componentClass}__action__description`}>{email}</div>
    </button>
    <PrintButton shouldOpenDetailsPage={ !!detailsUrl } className={`${componentClass}__action`}>
      <ReactSVG src="/classpath/assets/images/print-blue.svg" title={print}/>
      <div className={`${componentClass}__action__description`}>{print}</div>
    </PrintButton>
    <button className={`${componentClass}__action`} onClick={() => setSmsModalView(true)}>
      <ReactSVG src="/classpath/assets/images/smartphone-blue.svg" title={sms}/>
      <div className={`${componentClass}__action__description`}>{sms}</div>
    </button>

    <ShareViaEmailModal closeBtn={commonUI.closeButton} isOpen={ showEmailModal } onClose={ () => setEmailModalView(false) } className="modal--shareViaEmail"/>
    <ShareViaSmsModal closeBtn={commonUI.closeButton} isOpen={ showSmsModal } onClose={ () => setSmsModalView(false) } className="modal--shareViaSms"/>
  </div>
};

export default SocialActionsBar;
